module.exports = __webpack_public_path__ + "media/music3.1d85083c.mp3";